module.exports = __webpack_public_path__ + "img/swift-gls-gris-acero.78c6c56f.png";